import * as React from 'react'; // eslint-disable-line
import dayjs from 'dayjs';
import isBetween from 'dayjs/plugin/isBetween';

dayjs.extend(isBetween);

interface AddFYTotalsProps {
    dataRow: {
        date: string;
        value: number;
    }[];
    currentFinancialYear: number;
    financialYearStartMonth: number;
    isBalanceSheet: boolean;
    endOfForecast: string;
}

export const AddFYTotals = ({
    dataRow,
    currentFinancialYear,
    financialYearStartMonth,
    isBalanceSheet,
    endOfForecast,
}: AddFYTotalsProps) => {
    if (!dataRow.length) return <>{0}</>;

    let total = 0;

    const dataRowLength = dataRow.length;
    const start = dayjs(`${currentFinancialYear}-${financialYearStartMonth}`, 'YYYY-MM');
    const end = start.add(1, 'year');
    const endOfForecastDate = dayjs(endOfForecast);
    // check if balanceStart exceeds the endOfForecast date
    const balanceStart = start.add(11, 'month').isAfter(endOfForecast)
        ? endOfForecastDate // if it does, use the final month
        : start.add(11, 'month'); // otherwise use the 11th month from the start
    const balanceEnd = start.add(11, 'month').isAfter(endOfForecast) ? endOfForecastDate : end;
    // set the data start and end dates
    const dataStart = isBalanceSheet ? balanceStart : start;
    const dataEnd = isBalanceSheet ? balanceEnd : end;

    for (let i = 0; i < dataRowLength; i++) {
        // isBetween inclusive of start and end using '[]'
        if (dayjs(dataRow[i].date).isBetween(dataStart, dataEnd, null, '[]')) {
            total += dataRow[i].value;
        }
    }

    return <>{Number(total).toFixed(0)}</>;
};
